import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { DisplayOrder } from '../DisplayOrder';

export const Wrapper = styled.div`
  position: absolute;
  z-index: ${DisplayOrder.Controls};
  width: 100%;
  bottom: 0;
`;

export const Bar = styled(Box)`
  margin: 20px;
  background: rgba(17, 17, 17, 0.7);
  backdrop-filter: blur(2.5px);
  border-radius: 20px;
  padding: 16px;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
`;
